import { render, staticRenderFns } from "./brand-changes-record.vue?vue&type=template&id=ec21de62&scoped=true&"
import script from "./brand-changes-record.vue?vue&type=script&lang=js&"
export * from "./brand-changes-record.vue?vue&type=script&lang=js&"
import style0 from "./brand-changes-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-changes-record.vue?vue&type=style&index=1&id=ec21de62&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec21de62",
  null
  
)

export default component.exports